<template>
    <div class="vx-address">
        <div class="flex">
            <vx-basic-icon v-if="!hideIcon" class="mr-3 self-start" icon="MapPinIcon" />
            <div class="address-link">
                <a v-if="hasAddress" :href="placeLink" target="_blank">
                    <p v-for="(part, index) in addressLines" :key="index" v-html="part" />
                </a>
                <span v-else class="disabled text-danger"> No Address * </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'vx-address',
    props: {
        value: {
            type: Object
        },
        hideIcon: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        placeLink() {
            var addrStr = [this.streetAddress1, this.streetAddress2].nonNullOrEmpty().join('+')
            var extra = [this.suburb, this.state, this.postcode].nonNullOrEmpty().join('+')
            var lower = addrStr.toLowerCase()

            if (lower.startsWith('po ') || lower.startsWith('p.o. ') || lower.startsWith('p.o ')) {
                return `https://www.google.com.au/maps/place/${extra.replace(' ', '+')}`
            }
            var fullStr = `${addrStr}+${extra}`.replace(/[/\s]/g, '+')
            return `https://www.google.com.au/maps/place/${fullStr}`
        },
        hasAddress() {
            return this.value && this.addressLines.any()
        },
        address() {
            return this.value || {}
        },
        streetAddress1() {
            return this.address.streetAddress1
        },
        streetAddress2() {
            return this.address.streetAddress2
        },
        suburb() {
            return this.address.suburb
        },
        state() {
            return this.address.state
        },
        postcode() {
            return this.address.postcode
        },
        country() {
            return this.address.country
        },
        addressLines() {
            return [
                this.streetAddress1,
                this.streetAddress2,
                this.suburb,
                `${this.state}&nbsp;&nbsp;&nbsp;${this.postcode}`
            ].nonNullOrEmpty()
        }
    }
}
</script>

<style lang="scss" scoped>
.address-link a span {
    display: inline-block;
}
</style>
